export default "__VITE_PUBLIC_ASSET__f422e3a6__"